import {AzureLayer, isHeatMapDisabledXorIsOverlayPinEnabled} from "@esWebAPI/es/map/layer/azure/AzureLayer";
import { ILayerView, LayerInfo } from "@esWebAPI/es/model/Layer";
import {layer, source, Map, SymbolLayerOptions} from "azure-maps-control";
import {DatasourceManager} from "@esWebAPI/es/map/module/DatasourceManager";
import {ColorThematicStyler} from "@esWebAPI/es/map/styler/ColorThematicStyler";

export class AzurePieClusterLabelLayer implements AzureLayer {

    private readonly _map: Map;
    private readonly datasourceManager: DatasourceManager;
    private readonly colorStyler: ColorThematicStyler;

    private _layerView: ILayerView;
    private _layerInfo: LayerInfo;

    private datasourceId: string|undefined;
    private _layer: layer.BubbleLayer|undefined;

    constructor(map: Map, layerView: ILayerView, layerInfo: LayerInfo,
                datasourceManager: DatasourceManager, colorStyler: ColorThematicStyler) {
        this._map = map;
        this._layerView = layerView;
        this._layerInfo = layerInfo;
        this.datasourceManager = datasourceManager;
        this.colorStyler = colorStyler;
    }

    private getOpacity(){
        return this.colorStyler.getOpacity(this._layerView);
    }

    private getOptions() {

        const serverColor = this._layerView.styleSettings.defaultStyle.color;
        const luminance = es.util.color.getLuminanceOfServerColor(serverColor);
        const fontAndOutlineColor = luminance < 0.5 ? "rgba(255,255,255,1)" : "rgba(48,48,48,1)";

        return {
            iconOptions: {
                image: 'none'
            },
            textOptions: {
                textField: ['get' , 'point_count_abbreviated'],
                offset: [0, 0],
                minZoom: 0,
                maxZoom: 20,
                allowOverlap: true,
                ignorePlacement: true,
                color: fontAndOutlineColor,
                size: 14,
                opacity: ['ceil', this.getOpacity()]
            },
            visible: this._layerView.enabled && isHeatMapDisabledXorIsOverlayPinEnabled(this._layerView),
            filter: es.util.object.deepCopy(['has', 'point_count']),
            sourceLayer: this.datasourceId && this.datasourceManager.isPbf(this.datasourceId) ? 'es' : undefined,
        } as SymbolLayerOptions;
    }

    public create(datasource: source.Source): Promise<void> {
        this.datasourceId = datasource.getId();
        this._layer = new layer.SymbolLayer(datasource.getId(), this.getLayerId(), this.getOptions());
        this._map.layers.add(this._layer);
        return Promise.resolve();
    }

    public hide(): void {
        this._layer?.setOptions({visible: false});
    }

    public show(): void {
        this._layer?.setOptions({visible: true});
    }

    public remove(): void {
        const layerId = this.getLayerId();
        if (this._map.layers.getLayerById(layerId)) {
            this._map.layers.remove(layerId);
        }
        this._layer = undefined;
    }

    public async update(layerView: ILayerView, layerInfo: LayerInfo): Promise<void> {
        this._layerView = layerView;
        this._layerInfo = layerInfo;
        let options = this.getOptions();
        this._layer?.setOptions(options);
        return Promise.resolve();
    }

    public getLayerId(): string {
        return "pieClusterLabel_" + this._layerView.id;
    }

    public hideFeature(_featureId: number): void {
        es.log.warn("Not implemented");
    }

    public showFeatures(): void {
        es.log.warn("Not implemented");
    }

    public getAzureLayer(): layer.BubbleLayer | undefined {
        return this._layer;
    }
}